import Ajax from '@/lib/ajax'

export default {
  /**
   * 按类型获取主图列表
   */
  getPromotionFrameList(currentPage: number, pageSize: number, FrameType: number) {
    let params = {
      SkipCount: (currentPage - 1) <= 0 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
      FrameType
    }
    return Ajax.get(`/api/MarketingManagement/promotionFrame`, {
      params
    })
  },
  /**
   * 上传边框图
   */
  uploadPromotionFrame(obj: any) {
    return Ajax.post(`/api/MarketingManagement/promotionFrame`, obj)
  },
  /**
   * 删除边框图
   */
  deletePromotionFrame(ids: any[]) {
    return Ajax.delete(`/api/MarketingManagement/promotionFrame`, {
      params: {
        ids
      }
    })
  },
  /**
   * 修改边框图名称
   */
  updatePromotionFrameName(id: string, obj: any) {
    return Ajax.put(`/api/MarketingManagement/promotionFrame?id=${id}`, obj)
  }
}